// src/UserSwitchGuard.jsx
import { useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { persistor } from "./redux/store";

export default function UserSwitchGuard() {
  const userId = useSelector((s) => s.auth?.user?.id || null);
  const lastUserIdRef = useRef(null);

  useEffect(() => {
    try {
      const stored = localStorage.getItem("lastUserId");
      lastUserIdRef.current = stored ? JSON.parse(stored) : null;
    } catch (err) {
      console.warn("[UserSwitchGuard] Failed to parse lastUserId:", err);
      localStorage.removeItem("lastUserId"); // clear bad value
      lastUserIdRef.current = null;
    }
  }, []);

  useEffect(() => {
    if (userId !== lastUserIdRef.current) {
      // purge persisted redux to avoid cross-account bleed
      persistor.purge();

      try {
        localStorage.setItem("lastUserId", JSON.stringify(userId));
      } catch (err) {
        console.warn("[UserSwitchGuard] Failed to save lastUserId:", err);
      }

      lastUserIdRef.current = userId;
    }
  }, [userId]);

  return null;
}
